exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mid-content[data-v-235827d9]{margin:16px 0}.mid-content .total-view[data-v-235827d9]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:16px}.sub-detail[data-v-235827d9]{width:96%;margin:auto}", ""]);

// exports
